"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldVerticalSeparation = exports.ModelMutatorVerticalSeparation = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var unit_1 = require("../../../unit");
var collection_field_1 = require("../collection.field");
var marker_drawable_1 = require("../drawable/marker.drawable");
var vertical_separation_drawable_1 = require("../drawable/vertical.separation.drawable");
var ModelMutatorVerticalSeparation = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorVerticalSeparation, _super);
    function ModelMutatorVerticalSeparation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelMutatorVerticalSeparation.prototype.manual = function (newValue) {
        this.unlink();
        if (newValue == null || isNaN(newValue)) {
            this.state.setFieldValue(this.field.id, null);
        }
        else {
            this.state.setFieldValue(this.field.id, {
                value: newValue
            });
        }
    };
    ModelMutatorVerticalSeparation.prototype.clear = function () {
        this.manual(null);
    };
    ModelMutatorVerticalSeparation.prototype.drawable = function (marker) {
        var _a;
        // If this is the first marker to be linked,
        // or an existing top marker link is in a different Capture,
        // then set a new top marker with no bottom marker.
        if (!((_a = this.field.stateValue) === null || _a === void 0 ? void 0 : _a.drawableTop) || marker.captureId !== this.field.stateValue.captureId) {
            this.state.setFieldValue(this.field.id, {
                drawableTop: marker.id,
                drawableBottom: '',
                captureId: marker.captureId
            });
            return;
        }
        // If the top has already been linked then set the bottom marker
        // and create/update the Vertical Separation Drawable.
        var drawable = this.field.drawable
            ? this.field.drawable
            : vertical_separation_drawable_1.CollectionModelDrawableVerticalSeparation.createWithLabel(this.field.collection.getDrawableState(marker.captureId), this.field.stateValue.drawableTop, marker.id, this.field.id);
        this.state.setFieldValue(this.field.id, {
            drawableBottom: marker.id,
            drawableTop: this.field.stateValue.drawableTop,
            captureId: marker.captureId,
            drawableVerticalSeparation: drawable.id
        });
    };
    // This method is used to set the top / bottom drawables and label states
    // directly, during deserialization.
    ModelMutatorVerticalSeparation.prototype.setDrawables = function (drawableTop, drawableBottom, sep) {
        this.state.setFieldValue(this.field.id, {
            drawableTop: drawableTop.id,
            drawableBottom: drawableBottom === null || drawableBottom === void 0 ? void 0 : drawableBottom.id,
            captureId: drawableTop.captureId,
            drawableVerticalSeparation: sep === null || sep === void 0 ? void 0 : sep.id
        });
    };
    ModelMutatorVerticalSeparation.prototype.unlink = function () {
        var _a, _b, _c, _d;
        // Only unlink if currently linked.
        if (!((_a = this.field.stateValue) === null || _a === void 0 ? void 0 : _a.drawableTop) && !((_b = this.field.stateValue) === null || _b === void 0 ? void 0 : _b.drawableBottom) && !((_c = this.field.stateValue) === null || _c === void 0 ? void 0 : _c.drawableVerticalSeparation)) {
            return;
        }
        // Delete the Vertical Separation Drawable if it exists
        (_d = this.field.drawable) === null || _d === void 0 ? void 0 : _d.remove();
        var stateValue = this.field.stateValue;
        if (stateValue == null || stateValue.drawableTop == null || stateValue.captureId == null) {
            return;
        }
        this.state.setFieldValue(this.field.id, null);
        var drawableState = this.field.collection.getDrawableState(stateValue.captureId);
        if (drawableState.hasDrawable(stateValue.drawableTop)) {
            var drawableTop = drawableState.getDrawable(stateValue.drawableTop);
            drawableTop.label.unlink(this.field.id);
        }
        if (stateValue.drawableBottom && drawableState.hasDrawable(stateValue.drawableBottom)) {
            var drawableBottom = drawableState.getDrawable(stateValue.drawableBottom);
            drawableBottom.label.unlink(this.field.id);
        }
    };
    ModelMutatorVerticalSeparation.prototype.linkExistingMarkerOrCopy = function (destinationDrawableState, originalDrawable) {
        var myCopiedDrawable = null;
        // if original drawable is linked to multiple fields, check if already copied
        if (originalDrawable.label.links.length > 1) {
            var existingCopiedDrawable = destinationDrawableState.getAllDrawables()
                .filter(function (copiedDrawable) {
                return copiedDrawable instanceof marker_drawable_1.CollectionModelDrawableMarker
                    && copiedDrawable.y === originalDrawable.y;
            })[0];
            myCopiedDrawable = existingCopiedDrawable ? existingCopiedDrawable : null;
        }
        // create new drawable if not already existing
        if (!myCopiedDrawable) {
            myCopiedDrawable = originalDrawable.clone(destinationDrawableState);
        }
        myCopiedDrawable.label.linkVerticalSeparation(this.field);
        return myCopiedDrawable;
    };
    ModelMutatorVerticalSeparation.prototype.copy = function (from) {
        if (!from.stateValue) {
            this.clear();
            return true;
        }
        var fromCollection = from.collection;
        var toCollection = this.field.collection;
        var captureId = from.stateValue.captureId;
        // Do not copy if missing capture or if source field is not fully linked to top and bottom markers
        if (!captureId || !from.stateValue.drawableTop || !from.stateValue.drawableBottom || !from.stateValue.drawableVerticalSeparation) {
            return false;
        }
        var fromDrawableState = fromCollection.getDrawableState(captureId);
        var drawableTop = fromDrawableState.getDrawable(from.stateValue.drawableTop);
        var drawableBottom = fromDrawableState.getDrawable(from.stateValue.drawableBottom);
        var drawable = fromDrawableState.getDrawable(from.stateValue.drawableVerticalSeparation);
        // If copying to another collection, try to link to existing markers at the same heights before creating new ones.
        if (fromCollection !== toCollection) {
            var toDrawableState = toCollection.getDrawableState(captureId);
            if (toDrawableState.base == null) {
                this.copyBaseMarkers(fromCollection, captureId);
            }
            var copyDrawableTop = this.linkExistingMarkerOrCopy(toDrawableState, drawableTop);
            var copyDrawableBottom = this.linkExistingMarkerOrCopy(toDrawableState, drawableBottom);
            var copyDrawable = drawable.clone(toDrawableState);
            this.setDrawables(copyDrawableTop, copyDrawableBottom, copyDrawable);
            return true;
        }
        // Otherwise just reuse the existing markers by adding a new link to the existing markers to the field being copied into.
        this.setDrawables(drawableTop, drawableBottom, drawable);
        drawableTop.label.linkVerticalSeparation(this.field);
        drawableBottom.label.linkVerticalSeparation(this.field);
        return true;
    };
    // duplicated in height.field.ts
    ModelMutatorVerticalSeparation.prototype.copyBaseMarkers = function (fromCollection, captureId) {
        var collection = this.field.collection;
        var drawableState = collection.getDrawableState(captureId);
        var fromDrawableState = fromCollection.getDrawableState(captureId);
        var fromBaseMarker = fromDrawableState.base;
        if (fromBaseMarker != null) {
            var baseMarker = marker_drawable_1.CollectionModelDrawableMarker.createWithLabel(drawableState, fromBaseMarker.getVector(), fromBaseMarker.label.getVector(), undefined, core_api_1.MarkerType.BASE).marker;
            var fromBaseOffsetMarker = fromDrawableState.baseOffset;
            if (fromBaseOffsetMarker != null) {
                baseMarker.offset = fromBaseMarker.offset;
            }
        }
    };
    return ModelMutatorVerticalSeparation;
}(collection_field_1.ModelMutator));
exports.ModelMutatorVerticalSeparation = ModelMutatorVerticalSeparation;
var CollectionModelFieldVerticalSeparation = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldVerticalSeparation, _super);
    function CollectionModelFieldVerticalSeparation() {
        var _this = _super.apply(this, tslib_1.__spreadArray([], tslib_1.__read(arguments), false)) || this;
        _this._Mutator = new ModelMutatorVerticalSeparation(_this);
        return _this;
    }
    CollectionModelFieldVerticalSeparation.isVerticalSeparationField = function (f) {
        return f.schema.type === CollectionModelFieldVerticalSeparation.TYPE;
    };
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "Mutator", {
        get: function () {
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldVerticalSeparation.prototype.hasValue = function () {
        var stateValue = this.stateValue;
        if (stateValue == null) {
            return false;
        }
        if (!stateValue.drawableTop || !stateValue.drawableBottom) {
            return false;
        }
        return true;
    };
    CollectionModelFieldVerticalSeparation.prototype.hasDrawableTop = function () {
        var stateValue = this.stateValue;
        if (stateValue == null || !stateValue.drawableTop) {
            return false;
        }
        return true;
    };
    CollectionModelFieldVerticalSeparation.prototype.hasDrawableBottom = function () {
        var stateValue = this.stateValue;
        if (stateValue == null || !stateValue.drawableBottom) {
            return false;
        }
        return true;
    };
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "value", {
        get: function () {
            var _a, _b;
            var stateValue = this.stateValue;
            if (stateValue == null) {
                return null;
            }
            if (((_a = this.drawableTop) === null || _a === void 0 ? void 0 : _a.value) == null || ((_b = this.drawableBottom) === null || _b === void 0 ? void 0 : _b.value) == null) {
                return null;
            }
            return this.drawableTop.value - this.drawableBottom.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "drawable", {
        get: function () {
            var _a, _b;
            if (!((_a = this.stateValue) === null || _a === void 0 ? void 0 : _a.captureId) || !((_b = this.stateValue) === null || _b === void 0 ? void 0 : _b.drawableVerticalSeparation)) {
                return null;
            }
            var drawableState = this.collection.getDrawableState(this.stateValue.captureId);
            return drawableState.getDrawable(this.stateValue.drawableVerticalSeparation);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "drawableTop", {
        get: function () {
            var _a, _b;
            if (!((_a = this.stateValue) === null || _a === void 0 ? void 0 : _a.captureId) || !((_b = this.stateValue) === null || _b === void 0 ? void 0 : _b.drawableTop)) {
                return null;
            }
            var drawableState = this.collection.getDrawableState(this.stateValue.captureId);
            return drawableState.getDrawable(this.stateValue.drawableTop);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "drawableBottom", {
        get: function () {
            var _a, _b, _c;
            if (!((_a = this.stateValue) === null || _a === void 0 ? void 0 : _a.captureId) || !((_b = this.stateValue) === null || _b === void 0 ? void 0 : _b.drawableTop) || !((_c = this.stateValue) === null || _c === void 0 ? void 0 : _c.drawableBottom)) {
                return null;
            }
            var drawableState = this.collection.getDrawableState(this.stateValue.captureId);
            var d = drawableState.getDrawable(this.stateValue.drawableBottom);
            var top = drawableState.getDrawable(this.stateValue.drawableTop);
            top.pair = addPair(updatePair(top.pair), d.id);
            d.pair = addPair(updatePair(d.pair), top.id);
            return d;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "clearanceThresholdInMeters", {
        get: function () {
            var _a;
            return (_a = this.schema.clearanceThresholdInMeters) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "annotationLabel", {
        get: function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            //if we're self-title no need to search for field just return displayname
            var fieldId = this.schema.annotationLabelFieldId;
            if (fieldId === this.schema.id) {
                return this.schema.displayName;
            }
            var field = fieldId ? this.findAncestorField(this.parent, fieldId) : null;
            if ((!field || !field.schema.type)) {
                return (_a = this.parent.title) !== null && _a !== void 0 ? _a : '';
            }
            switch (field.schema.type) {
                case core_api_1.IkeFieldType.ANCHOR:
                    // I think to get the complex values we have to type them first and put them together ourselves
                    if (field.hasValue()) {
                        var anchor = field.value;
                        return "".concat(anchor.collectionTool, " ").concat(anchor.placement);
                    }
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.DATE:
                    var date = field;
                    if (!date.hasValue() || date.displayValue == null || date.displayValue === '') {
                        return (_b = this.parent.title) !== null && _b !== void 0 ? _b : '';
                    }
                    return date.displayValue;
                case core_api_1.IkeFieldType.FILE_TOOL:
                    var fileTool = field;
                    if (!fileTool.hasValue() || fileTool.displayValue == null || fileTool.displayValue === '') {
                        return (_c = this.parent.title) !== null && _c !== void 0 ? _c : '';
                    }
                    return fileTool.displayValue;
                case core_api_1.IkeFieldType.FORM:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.HEIGHT:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.IMAGE:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.LOCATION:
                    var loc = field;
                    if (!loc.hasValue() || loc.displayValue == null || loc.displayValue === '') {
                        return (_d = this.parent.title) !== null && _d !== void 0 ? _d : '';
                    }
                    var locVal = loc.value;
                    return "".concat(locVal.latitude.toFixed(2), ",").concat(locVal.longitude.toFixed(2));
                case core_api_1.IkeFieldType.NESTED_LIST:
                    if (!field.hasValue() || field.displayValue == null || field.displayValue === '') {
                        return (_e = this.parent.title) !== null && _e !== void 0 ? _e : '';
                    }
                    return field.displayValue;
                case core_api_1.IkeFieldType.NUMBER:
                    if (!field.hasValue() || field.displayValue == null || field.displayValue === '') {
                        return (_f = this.parent.title) !== null && _f !== void 0 ? _f : '';
                    }
                    return field.displayValue;
                case core_api_1.IkeFieldType.SELECT_LIST:
                    if (!field.hasValue() || field.displayValue == null || field.displayValue === '') {
                        return (_g = this.parent.title) !== null && _g !== void 0 ? _g : '';
                    }
                    return field.displayValue;
                case core_api_1.IkeFieldType.TEXT:
                    if (!field.hasValue() || field.displayValue == null || field.displayValue === '') {
                        return (_h = this.parent.title) !== null && _h !== void 0 ? _h : '';
                    }
                    return field.displayValue;
                case core_api_1.IkeFieldType.TRUE_SIZE:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.VECTOR:
                    var vector = field.value;
                    if (field.hasValue()) {
                        return "".concat(unit_1.IkeUnit.display(vector.distance, this.distanceUnit, unit_1.IkeUnit.METER, core_api_1.IkeUnitType.DISTANCE, 1), " ").concat(unit_1.IkeUnit.display(vector.bearing, unit_1.IkeUnit.DEGREE, unit_1.IkeUnit.RADIAN, core_api_1.IkeUnitType.ANGLE, 1));
                    }
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.VERTICAL_SEPARATION:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.YES_NO:
                    return field.schema.displayName;
                default:
                    return (_j = this.parent.title) !== null && _j !== void 0 ? _j : '';
            }
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldVerticalSeparation.prototype.getOwnedCaptures = function () {
        return this.getCaptures();
    };
    CollectionModelFieldVerticalSeparation.prototype.getCaptures = function () {
        var _this = this;
        return this.getCaptureIds().map(function (c) { return _this.collection.state.getCapture(c); }).filter(function (c) { return !!c; });
    };
    CollectionModelFieldVerticalSeparation.prototype.getOwnedCaptureIds = function () {
        return this.getCaptureIds();
    };
    CollectionModelFieldVerticalSeparation.prototype.getCaptureIds = function () {
        return [];
    };
    CollectionModelFieldVerticalSeparation.TYPE = core_api_1.IkeFieldType.VERTICAL_SEPARATION;
    return CollectionModelFieldVerticalSeparation;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldVerticalSeparation = CollectionModelFieldVerticalSeparation;
var updatePair = function (pair) {
    if (typeof pair === 'string') {
        return [pair];
    }
    return pair;
};
var addPair = function (pair, newPairedId) {
    if (pair == null) {
        return [newPairedId];
    }
    if (pair.includes(newPairedId)) {
        return pair;
    }
    return tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(pair), false), [newPairedId], false);
};
//# sourceMappingURL=vertical.separation.field.js.map